import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ReactComponent as VerificationIcon } from '@pkg/assets/icons/v2/verification.svg';

export const NFTCollectionWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledVerificationIcon = styled(motion(VerificationIcon))`
    flex: none;
    margin-right: 8px;
    color: transparent;
`;

export const CollectionAndChildrenWrapper = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px;
`;
